<template>
  <a-card>
    <elwrapper label="Internal title" midtext>
      <f-text v-model="internalTitle" />
      <div class="caption grey--text mt-1">Used in the database list and when picking a page for a quote.</div>
    </elwrapper>
    <elwrapper label="Program title" midtext>
      <f-textarea v-model="title" rows="3" />
      <div class="caption grey--text mt-1">
        Shown on the printed page. Optional: first line = smaller intro, following lines = main title
      </div>
    </elwrapper>
    <elwrapper label="Type" midtext>
      <f-dropdown :items="typeItems" :value="type" hideClear @input="onTypeChange" />
    </elwrapper>
    <elwrapper label="Content" midtext>
      <ProgramPageContentEditor :title="title" :type="type" :value="content" @input="onContentChange" />
    </elwrapper>
  </a-card>
</template>

<script>
import ProgramPageContentEditor from "./ProgramPageContentEditor";
import { PAGE_TYPES, DEFAULT_PAGE_TYPE, normalizePageContent, normalizePageType } from "../utils";

export default {
  components: {
    ProgramPageContentEditor,
  },
  computed: {
    typeItems() {
      return PAGE_TYPES.map((item) => ({ label: item.label, value: item.value }));
    },
    internalTitle: {
      get() {
        return this.get("internal_title") || "";
      },
      set(newValue) {
        return this.set("internal_title", newValue);
      },
    },
    title: {
      get() {
        return this.get("title") || "";
      },
      set(newValue) {
        return this.set("title", newValue);
      },
    },
    type() {
      return normalizePageType(this.get("type") || DEFAULT_PAGE_TYPE);
    },
    content() {
      return normalizePageContent(this.type, this.get("content"));
    },
  },
  methods: {
    get(val) {
      return this.$store.getters["ProgramPageStore/active"][val];
    },
    set(key, val) {
      return this.$store.dispatch("ProgramPageStore/setUpdate", { key, val });
    },
    onTypeChange(nextType) {
      const normalized = normalizePageType(nextType);
      if (this.type === normalized) return;
      this.set("type", normalized);
    },
    onContentChange(content) {
      this.set("content", normalizePageContent(this.type, content));
    },
  },
};
</script>
